import { RgbaColor } from 'colord';
import { styled } from 'styled-components';
import { NumberInput } from '../NumberInput';

export const AdditionalInputs = ({
  rgba,
  updateColor,
}: {
  rgba?: RgbaColor;
  updateColor: (newColor: RgbaColor) => void;
}) => {
  return (
    <>
      <Inputs>
        <NumberInput
          id={`color-picker-r-input`}
          label="r"
          value={rgba?.r}
          defaultValue={0}
          onChange={(newNumberValue) => {
            const color = rgba;
            if (color) color.r = newNumberValue;
            updateColor(color as RgbaColor);
          }}
          centered
        />
        <NumberInput
          id={`color-picker-g-input`}
          label="g"
          value={rgba?.g}
          defaultValue={0}
          onChange={(newNumberValue) => {
            const color = rgba;
            if (color) color.g = newNumberValue;
            updateColor(color as RgbaColor);
          }}
          centered
        />
        <NumberInput
          id={`color-picker-b-input`}
          label="b"
          value={rgba?.b}
          defaultValue={0}
          onChange={(newNumberValue) => {
            const color = rgba;
            if (color) color.b = newNumberValue;
            updateColor(color as RgbaColor);
          }}
          centered
        />
      </Inputs>
      <NumberInput
        id={`color-picker-a-input`}
        label="a"
        value={rgba?.a}
        defaultValue={0}
        onChange={(newNumberValue) => {
          const color = rgba;
          if (color) color.a = newNumberValue;
          updateColor(color as RgbaColor);
        }}
        centered
      />
    </>
  );
};

const Inputs = styled.div`
  width: 200px;
  margin: 10px 0;
  display: flex;
  gap: 5px;

  & > * {
    width: 33%;
  }
`;
